import { createFileRoute } from '@tanstack/react-router'
import EditionSales from 'Edition/components/sections/General/EditionSales'

import { Guard } from '../../../../-guard'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/general-sales')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <EditionSales />
        </Guard>
    ),
})
